export default __webpack_public_path__ + "assets/images/447d71caa1642cef4953dff06fc01df6.jpg";